
import React, { Component } from "react";
import "./Compiler.css";
import {
    Button,
    Grid,
    Tooltip,
} from "@mui/material";

export default class Compiler extends Component {
    constructor(props) {
        super(props);
        this.state = {
            input: localStorage.getItem('input') || ``,
            output: ``,
            language_id: localStorage.getItem('language_Id') || 2,
            user_input: ``,
            options: [],
        };
    }
    input = (event) => {
        event.preventDefault();
        this.setState({ input: event.target.value });
        localStorage.setItem('input', event.target.value)
    };

    userInput = (event) => {
        event.preventDefault();
        this.setState({ user_input: event.target.value });
    };

    language = (event) => {
        event.preventDefault();
        this.setState({ language_id: event.target.value });
        localStorage.setItem('language_Id', event.target.value)
        this.resetInputAreas();
    };

    submit = async (e) => {
        e.preventDefault();
        let outputText = document.getElementById("output");
        outputText.innerHTML = "";
        outputText.innerHTML += "Creating Submission ...\n";
    
        // Function to handle fetch with timeout
        const fetchWithTimeout = (url, options, timeout = 5000) =>
            Promise.race([
                fetch(url, options),
                new Promise((_, reject) =>
                    setTimeout(() => reject(new Error("Request timeout")), timeout)
                ),
            ]);
    
        let response;
        try {
            // Try to fetch submission creation
            response = await fetchWithTimeout(
                `${process.env.REACT_APP_COMPILE}/`,
                {
                    method: "POST",
                    headers: {
                        "content-type": "application/json",
                        accept: "application/json",
                    },
                    body: JSON.stringify({
                        source_code: this.state.input,
                        stdin: this.state.user_input,
                        language_id: this.state.language_id,
                    }),
                }
            );
            outputText.innerHTML += "Submission Created ...\n";
        } catch (error) {
            console.error("Fetch error:", error);
            outputText.innerHTML += `Error: ${error.message}`;
            return; // Exit if fetch fails
        }
    
        let jsonResponse;
        try {
            jsonResponse = await response.json();
            // console.log("js-r", jsonResponse);
        } catch (error) {
            console.error("Error parsing JSON response:", error);
            outputText.innerHTML += "Error: Failed to parse submission response.";
            return;
        }
    
        let retries = 0;
        const maxRetries = 200;
        let jsonGetSolution = {
            status: { description: "Queue" },
            stderr: null,
            compile_output: null,
        };
    
        // Poll for solution status
        while (
            retries < maxRetries &&
            jsonGetSolution.status.description !== "Accepted" &&
            jsonGetSolution.stderr == null &&
            jsonGetSolution.compile_output == null
        ) {
            retries++;
            outputText.innerHTML = `Creating Submission ... \nSubmission Created ...\nChecking Submission Status\nstatus : ${jsonGetSolution.status.description}`;
            try {
                if (jsonResponse.token) {
                    let url = `${process.env.REACT_APP_COMPILE}/${jsonResponse.token}?base64_encoded=true`;
                    // let tt = 'https://extra-ce.judge0.com'
                    // let url = `${tt}/${jsonResponse.token}?base64_encoded=true`;
                    const getSolution = await fetchWithTimeout(url, {
                        method: "GET",
                        headers: {
                            "content-type": "application/json",
                        },
                    });
                    jsonGetSolution = await getSolution.json();
                }
            } catch (error) {
                console.error("Error fetching solution status:", error);
                outputText.innerHTML += `\nError: Failed to fetch solution status.`;
                return;
            }
        }
    
        if (retries === maxRetries) {
            outputText.innerHTML = "Error: Maximum retries exceeded. Please try again later.";
            
            return;
        }
    
        // Display results
        if (jsonGetSolution.stdout) {
            const output = atob(jsonGetSolution.stdout);
            outputText.innerHTML = "";
            outputText.innerHTML += `Results :\n${output}\nExecution Time : ${jsonGetSolution.time} Secs\nMemory used : ${jsonGetSolution.memory} bytes`;
        } else if (jsonGetSolution.stderr) {
            const error = atob(jsonGetSolution.stderr);
            outputText.innerHTML = "";
            outputText.innerHTML += `\n Error :${error}`;
        } else {
            const compilation_error = atob(jsonGetSolution.compile_output);
            outputText.innerHTML = "";
            outputText.innerHTML += `\n Error :${compilation_error}`;
        }
    };
    

    // componentDidMount() {
    //     if (localStorage.getItem('input') || localStorage.getItem('user_input')) {
    //         localStorage.removeItem('input');
    //         localStorage.removeItem('user_input');
    //         this.setState({ input: ``, user_input: `` });
    //     }
    //     fetch("https://ce.judge0.com/languages/")
    //         .then(response => response.json())
    //         .then(data => {
    //             this.setState({ options: data });
    //         })
    //         .catch(error => console.error("Error fetching language options:", error));
    // }

    componentDidMount() {
        fetch("https://ce.judge0.com/languages/")
            .then((response) => response.json())
            .then((data) => {
                // Filter out invalid IDs (like 101 if it doesn't exist in Judge0)
                const validOptions = data.filter((language) => language.id !== 101);
                this.setState({ options: validOptions });
            })
            .catch((error) => console.error("Error fetching language options:", error));
    }

    resetInputAreas = () => {
        this.setState({
            input: ``,
            output: ``,
            user_input: ``,
        });
        document.getElementById("output").innerHTML = "";
    };

    render() {
        return (
            <>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <div className="container-fluid">
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <div className="col-6 ml-4 left-side">
                                <label htmlFor="solution">
                                    <span className="badge badge-info heading" style={{ borderRadius: '50px', padding: '6px 12px' }}>
                                        <i className="fas fa-code fa-fw fa-lg icon"></i> Code Here :
                                    </span>
                                </label>
                                <textarea
                                    required
                                    name="solution"
                                    id="source"
                                    onChange={this.input}
                                    className="source"
                                    value={this.state.input}
                                ></textarea>
                                <div style={{ display: "flex", alignItems: "flex-start" }}>
                                    <label htmlFor="tags">
                                        <span className="badge badge-info heading" style={{ borderRadius: '50px', padding: '6px 12px' }}>
                                            Language :
                                        </span>
                                    </label>
                                    <Tooltip title="Select the programming language to compile with">
                                        <select
                                            value={this.state.language_id}
                                            onChange={this.language}
                                            id="tags"
                                            className="form-control form-inline mb-2 language"
                                            style={{ marginLeft: "10px", marginRight: "auto", marginTop: "10px" }}
                                        >
                                            {this.state.options.map(option => (
                                                <option key={option.id} value={option.id}>{option.name}</option>
                                            ))}
                                        </select>
                                    </Tooltip>
                                    <Tooltip title="Run and execute your code">
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            onClick={this.submit}
                                            style={{ marginLeft: "auto", borderRadius: '50px' }}
                                        >
                                            Run
                                        </Button>
                                    </Tooltip>
                                </div>
                                <div className="user-input">
                                    <span className="badge badge-primary heading" style={{ borderRadius: '50px', padding: '6px 12px' }}>
                                        <i className="fas fa-user fa-fw fa-md icon"></i> User Input :
                                    </span>
                                    <br />
                                    <Tooltip title="Optional: provide stdin for your program">
                                        <textarea
                                            id="input"
                                            onChange={this.userInput}
                                            style={{ marginTop: "10px" }}
                                        ></textarea>
                                    </Tooltip>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6} className="right-side">
                            <div className="col-4">
                                <div style={{ display: "flex", alignItems: "flex-start" }}>
                                    <span className="badge badge-info heading my-2" style={{ borderRadius: '50px', padding: '6px 12px' }}>
                                        <i className="fas fa-exclamation fa-fw fa-md icon"></i> Output :
                                    </span>
                                </div>
                                <div className="output-container">
                                    <textarea id="output" className="output"></textarea>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </>
        );
    }
}